// Component to render the profile card
// Import react
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

// Import supabase configuration
import supabase from "../config/supabase";
import { Buffer } from "buffer";
import Header from "../components/header/header";
import MuiSelect from "@mui/material/Select";
import Button from "../components/button/button";
import MenuItem from "@mui/material/MenuItem";
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import Snackbar from "@mui/material/Snackbar";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import MuiButton from "@mui/material/Button";
import axios from "axios";
// Import skelton
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Oval } from "react-loader-spinner";

import { getAllBoards } from "../redux/actions/boardActions";

// Import the main component
import { Viewer, Worker } from "@react-pdf-viewer/core";
// Import the styles

import "@react-pdf-viewer/core/lib/styles/index.css";
import sampleFile from "../asstes/sample.pdf";
import { nanoid } from "nanoid";

export default function Profile() {
  const dispatch = useDispatch();

  const [url, setUrl] = useState("/avatar.png");
  const initialState = useSelector((state) => state.boards);
  const [profileId, setProfileId] = useState("");
  const [profile, setProfile] = useState({
    id: "",
    name: "",
    email: "",
    projects: [],
    education: {},
    exp: "",
    location: "",
    top_3_technologies: "",
    primary_skills: [],
    contract_status: "",
    timezone: "",
    career_summary: "",
    dp: "",
    current_job_title: "",
    expected_hourly_rate: "",
    cv_link: "",
  });
  const [filteredProfiles, setFilteredProfiles] = useState([]);
  const [bestProfiles, setBestProfiles] = useState([]);
  const [partialProfiles, setPartialProfiles] = useState([]);
  const [selectedProfiles, setSelectedProfiles] = useState([]);
  const [profilesAddedInBoard, setProfilesAddedInBoard] = useState([]);
  const [showButton, setShowButton] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [clientView, setClientView] = useState(false);
  const [message, setMessage] = useState("");
  const [boards, setBoards] = useState([]);
  const [selectedBoard, setSelectedBaord] = useState("");
  const [boardId, setBaordId] = useState("");
  const [saveButtonStyle, setSaveButtonStyle] = useState("w-32 bg-pink-1");
  const [showLoader, setShowLoader] = useState(false);
  const [loading, setLoading] = useState(true);
  const [cv, setCv] = useState("");

  useEffect(async () => {
    document.title = "Profile";

    dispatch(getAllBoards());
    var url = new URL(window.location.href);

    var getValue = window.location.href.split("=")[2];
    if (getValue == "true") {
      setClientView(true);
    }

    var profileId = Buffer.from(
      url.searchParams.get("id") || "",
      "base64"
    ).toString("utf-8");
    setProfileId(profileId);

    getProfileDetails(profileId);
  }, []);

  useEffect(() => {
    setBoards(initialState);
    initialState.length && setSelectedBaord(initialState[0].name);
  }, [initialState]);

  const StyledInput = styled(InputBase)(({ theme }) => ({
    "& .MuiInputBase-input": {
      "&:focus": {
        borderRadius: 4,
        borderColor: "",
        boxShadow: "",
      },
    },
  }));

  // undo profile
  const undoProfileAddition = async () => {
    // Delete profiles
    // Get a copy of all profiles in board
    var profiles = profilesAddedInBoard;

    // Get copy of currently selected profiles
    var selected_profiles = selectedProfiles;

    var selected = [];
    profiles.forEach((profile) => {
      var check = false;
      // Find the selected profile and push to selected
      selected_profiles.forEach((p) => {
        if (p.id == profile.id) {
          check = true;
        }
      });
      !check && selected.push(profile);
    });

    const { data, error } = await supabase
      .from("board_profiles")
      .update({ profiles: selected })
      .match({ board: boardId });

    var unCheckedProfiles = filteredProfiles.map((p) => ({
      ...p,
      checked: false,
    }));
    var unCheckBestProfiles = bestProfiles.map((p) => ({
      ...p,
      checked: false,
    }));
    var unCheckPartialProfiles = partialProfiles.map((p) => ({
      ...p,
      checked: false,
    }));
    setPartialProfiles(unCheckPartialProfiles);
    setBestProfiles(unCheckBestProfiles);
    setFilteredProfiles(unCheckedProfiles);

    setShowButton(false);
    setShowMessage(false);
    setSaveButtonStyle("w-32 bg-pink-1");
  };

  // get all boards profiles
  const getAllBoardProfiles = async (boardId) => {
    const { data, error } = await supabase
      .from("board_profiles")
      .select("*")
      .match({ board: boardId });

    if (data && data.length > 0) {
      var dataObject = {
        profiles: data[0].profiles,
        alreadyBoardAvailable: true,
      };
      return dataObject;
    } else {
      var dataObject = {
        profiles: [],
        alreadyBoardAvailable: false,
      };
      return dataObject;
    }
  };

  const action = (
    <React.Fragment>
      {saveButtonStyle !== "w-32 bg-pink-1" && (
        <MuiButton
          color="secondary"
          size="small"
          onClick={() => undoProfileAddition()}
        >
          UNDO
        </MuiButton>
      )}
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={() => setShowMessage(false)}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  // Change board
  const changeBoard = (event) => {
    setSelectedBaord(event.target.value);
  };

  // Function for profile addition
  const addSelection = async () => {
    setShowLoader(true);
    // Get board id
    var boardId = boards.find((b) => b.name == selectedBoard).id;
    setBaordId(boardId);

    // Get a copy of profiles
    var profiles = [...bestProfiles, ...partialProfiles];

    var presentInBoard = false;
    var dataObject = await getAllBoardProfiles(boardId);

    var resultedProfiles = dataObject.profiles;
    var available = dataObject.alreadyBoardAvailable;
    resultedProfiles = resultedProfiles || [];
    var selected = [];

    // Loop over profiles

    // Find the selected profile and check if already in selected board
    var included = false;
    resultedProfiles &&
      resultedProfiles.forEach((rp) => {
        if (rp.id === profile.id) {
          included = true;
        }
      });
    // Add to selection

    var obj = {
      id: profile.id,
      status: "New",
      message: "",
      meetingTime: "",
      endMeetingTime: "",
      rate: profile.expected_hourly_rate,
      paymentFrequency: "Hourly"
    };
    
    !included && selected.push(obj);

    setSelectedProfiles(selected);

    selected = [...resultedProfiles, ...selected];

    setProfilesAddedInBoard(selected);

    if (resultedProfiles.length <= 0 && !available) {
      let masked_url = window.location.origin + "/redirect?" + nanoid().substring(0, 6);

      const { data, error } = await supabase
        .from("board_profiles")
        .insert({ board: boardId, profiles: selected ,masked_url: masked_url});

      if (data && data.length) {
        setSaveButtonStyle("w-32 bg-black-1");
        setShowMessage(true);
        setMessage("Profile is added successfully.");
        setTimeout(function () {
          setShowButton(false);
          setSaveButtonStyle("w-32 bg-pink-1");
          var unCheckedProfiles = [...filteredProfiles];
          unCheckedProfiles = unCheckedProfiles.map((p) => ({
            ...p,
            checked: false,
          }));

          var unCheckBestProfiles = [...bestProfiles];
          unCheckBestProfiles = unCheckBestProfiles.map((p) => ({
            ...p,
            checked: false,
          }));
          var unCheckPartialProfiles = [...partialProfiles];
          unCheckPartialProfiles = unCheckPartialProfiles.map((p) => ({
            ...p,
            checked: false,
          }));
          setBestProfiles(unCheckBestProfiles);
          setPartialProfiles(unCheckPartialProfiles);
          setFilteredProfiles(unCheckedProfiles);
        }, 3000);
      }
    } else if (selected.length - resultedProfiles.length > 0) {
      const { data, error } = await supabase
        .from("board_profiles")
        .update({ profiles: selected })
        .match({ board: boardId });

      if (data && data.length) {
        setSaveButtonStyle("w-32 bg-black-1");
        setShowMessage(true);
        setMessage("Profile is added successfully.");
        setTimeout(function () {
          setShowButton(false);
          setSaveButtonStyle("w-32 bg-pink-1");
          var unCheckedProfiles = [...filteredProfiles];
          unCheckedProfiles = unCheckedProfiles.map((p) => ({
            ...p,
            checked: false,
          }));

          var unCheckBestProfiles = [...bestProfiles];
          unCheckBestProfiles = unCheckBestProfiles.map((p) => ({
            ...p,
            checked: false,
          }));
          var unCheckPartialProfiles = [...partialProfiles];
          unCheckPartialProfiles = unCheckPartialProfiles.map((p) => ({
            ...p,
            checked: false,
          }));
          setBestProfiles(unCheckBestProfiles);
          setPartialProfiles(unCheckPartialProfiles);
          setFilteredProfiles(unCheckedProfiles);
        }, 3000);
        getScreenShot(boardId);
      }
    } else {
      setShowMessage(true);
      setMessage("Profile already exists in board.");
      setTimeout(function () {
        setShowMessage(false);
      }, 3000);
    }
    setShowLoader(false);
  };

  const getProfileDetails = async (id) => {
    const { data, error } = await supabase
      .from("all_profiles")
      .select("*")
      .match({ id: id });

    var profile = data[0];

    if (profile && profile.dp) {
      // get url for dp
      const { signedUrl, data, error } = await supabase.storage
        .from("data")
        .createSignedUrl(profile.dp, 600);

      if (data) {
        // set url
        setUrl(data["signedURL"]);
      }
    }

    var p = {
      id: profile.id,
      name: profile.full_name,
      email: profile.email,
      projects: [
        {
          title: profile.project_title1,
          description: profile.project_description1,
          role: profile.project_role1,
          technologies_used: profile.technologies_used1,
        },
        {
          title: profile.project_title2,
          description: profile.project_description2,
          role: profile.project_role2,
          technologies_used: profile.technologies_used2,
        },
        {
          title: profile.project_title3,
          description: profile.project_description3,
          role: profile.project_role3,
          technologies_used: profile.technologies_used3,
        },
      ],
      education: {
        uni: profile.university,
        cgpa: profile.cgpa,
        year_of_graduation: profile.year_of_graduation,
      },
      exp: profile.exp,
      location: profile.location,
      top_3_technologies: profile.top_3_technologies,
      primary_skills: profile.skill_level,
      contract_status: profile.contract_status,
      timezone: profile.timezone,
      career_summary: profile.career_summary,
      dp: profile.dp,
      current_job_title: profile.current_job_title,
      expected_hourly_rate: profile.expected_hourly_rate,
      cv_link: profile.cv_link,
    };
    setProfile(p);
    setLoading(false);

  };

  const getScreenShot =  async(Id) => {
    var id = Buffer.from(Id,
      "utf-8"
    ).toString("base64");

   await axios
   .get(`https://shot.screenshotapi.net/screenshot?token=R5XWFXS-QF2MD5V-N6CF9CZ-F7Z08EF&url=https://ats-search.netlify.app/sharedProfiles?id=${id}&width=1040&height=750&delay=5000`)
   .then( async(response) => {  
    const Image = response.data.screenshot;
    // setScreenShotImage(Image);
    const { data, error } = await supabase
        .from("board_profiles")
        .update({ profiles_screenshot: Image })
        .match({ board: Id });

   })
   .catch(function (error) {
     console.log("error in taking screenshot", error);
   });
  };

  return (
    <>
      <Header clientView={true} />

      {showLoader && (
        <div className="fixed flex items-center justify-center z-10 w-full h-full top-0 bg-white-1">
          {/* Add backdrop */}
          
          <div className={`relative flex`}>
            <Oval
                color="white"
                secondaryColor="grey"
                height="40"
                width="60"
              />
              <div className="flex items-center">Hold Tight-just getting this page ready.</div>
          </div>
        </div>
      )}

      <Snackbar
        open={showMessage}
        onClose={() => setShowMessage(false)}
        autoHideDuration={3000}
        message={message}
        action={action}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      />

      <div className="w-full h-auto">
        {/* Add div */}
        <div className="bg-blue-2 h-1xl w-full col-span-12"></div>

        {/* Body */}
        <div className="bg-white-5 col-span-12 flex justify-center">
          <div className="lg:w-profile_building lg:self-center ">
            {/* Personal View Sections */}
            <div className="col-span-12 grid grid-cols-12 gap-3 ">
              {/* Basic Info section */}
              <div className="bg-white-1 col-span-12 grid grid-cols-12 gap-3 rounded font-Poppins px-9 pt-9 pb-12 mb-5 -mt-20">
                <div className="col-span-12 grid grid-cols-12 gap-3">
                  {/* Show skelton on loading*/}
                  {loading ? (
                    <div className="col-span-12 grid grid-cols-12 gap-3">
                      <div className="col-span-6 h-40 w-40 -mt-32 md:h-60 md:w-60 md:-mt-40">
                        <Skeleton
                          circle={true}
                          height={`100%`}
                          width={`100%`}
                        />
                      </div>
                      {!clientView && (
                        <div className="col-span-6 flex justify-end">
                          <Skeleton height={35} width={225} />
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className={`col-span-12 flex grid grid-cols-12 gap-3`}>
                      <div className="col-span-6">
                        <img
                          className={`rounded-full bg-white-6 border-grey-1 border-2 h-40 w-40 -mt-32 md:h-60 md:w-60 md:-mt-40`}
                          src={url}
                          alt="Avatar"
                        />
                      </div>

                      {!clientView && boards.length > 0 && (
                        <div className="flex space-x-2 justify-end col-span-6">
                          {saveButtonStyle == "w-32 bg-pink-1" ? (
                            <MuiSelect
                              labelId="boards"
                              id="boards"
                              className="-mt-8"
                              label={selectedBoard}
                              value={selectedBoard}
                              onChange={changeBoard}
                              input={<StyledInput />}
                            >
                              {boards.map((b) => (
                                <MenuItem key={b.name} value={b.name}>
                                  {b.name}
                                </MenuItem>
                              ))}
                            </MuiSelect>
                          ) : (
                            <p className="flex items-center mr-6 text-base -mt-8 font-semibold">
                              {selectedBoard}
                            </p>
                          )}

                          <Button
                            value={
                              saveButtonStyle == "w-32 bg-pink-1"
                                ? "Save"
                                : "Saved"
                            }
                            buttonType="search"
                            className={saveButtonStyle}
                            onClick={() => addSelection()}
                          />
                        </div>
                      )}
                    </div>
                  )}
                </div>

                <div className="col-span-12 mt-3">
                  {/* Show skelton on loading*/}
                  {loading ? (
                    <div className="col-span-12 mt-2 grid grid-cols-12 gap-3">
                      <div className="col-span-12 md:col-span-3">
                        <Skeleton height={35} width={300} />
                      </div>
                    </div>
                  ) : (
                    <div className="col-span-12 grid grid-cols-12 gap-3 mt-3">
                      {/* Add text */}
                      <div
                        className={`flex col-span-12 md:col-span-8 lg:col-span-9`}
                      >
                        <span className="text-black-1 text-4xl font-semibold">
                          {profile.name}
                        </span>
                      </div>
                    </div>
                  )}
                </div>

                <div className="col-span-12 grid grid-cols-12 gap-3">
                  {/* Show skelton on loading*/}
                  {loading ? (
                    <div className="col-span-12 md:col-span-6 mt-2 grid grid-cols-12 gap-3">
                      <div className="col-span-12 md:col-span-6">
                        <Skeleton height={30} width={260} />
                      </div>

                      {/* Space */}
                      <div className="hidden md:flex md:col-span-2"></div>

                      <div className="col-span-12 md:col-span-3">
                        <Skeleton height={30} />
                      </div>
                    </div>
                  ) : (
                    <div className="grid grid-cols-12 gap-3 col-span-12">
                      {/* Add job title */}
                      <div className="col-span-12 md:col-span-4">
                        <span className="text-black-1 text-2xl font-normal">
                          {profile.current_job_title}
                        </span>
                      </div>

                      {/* Add location */}
                      {profile.location && (
                        <div className="flex col-span-12 md:col-span-8">
                          <img
                            className="h-location_icon w-location_icon mr-5 mt-3"
                            src="/location_icon.png"
                            alt="Avatar"
                          />
                          <span className="text-black-1 text-2xl font-light leading-9">
                            {profile.location}
                          </span>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {/* Add text and icon */}
                <div className="col-span-12 grid grid-cols-12 gap-3">
                  {/* Show skelton on loading*/}
                  {loading ? (
                    <div className="col-span-12 flex">
                      <Skeleton height={30} width={260} />
                      <div className="ml-40">
                        <Skeleton height={30} width={140} />
                      </div>
                      <div className="ml-36">
                        <Skeleton height={30} width={140} />
                      </div>
                      <div className="ml-36">
                        <Skeleton height={30} width={140} />
                      </div>
                    </div>
                  ) : (
                    <div className="flex col-span-12 grid grid-cols-12 gap-3">
                      {profile.timezone && (
                        <div className="flex col-span-4">
                          <svg
                            className="mt-1"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="18"
                            height="18"
                          >
                            <path fill="none" d="M0 0h24v24H0z" />
                            <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm1-8h4v2h-6V7h2v5z" />
                          </svg>
                          <span className="text-black-1 text-xl font-light ml-4">
                            {profile.timezone}
                          </span>
                        </div>
                      )}

                      {/* Column for experience and contract */}
                      <div className="col-span-8 grid grid-cols-12 gap-3">
                        {/* Render exp */}
                        {profile.exp && (
                          <div className="w-full mb-2 text-black-1 text-xl font-light flex items-center col-span-4">
                            {/* Icon */}
                            <svg
                              className="mr-2"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="18"
                              height="18"
                            >
                              <path fill="none" d="M0 0h24v24H0z" />
                              <path d="M20 22H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1zm-1-2V4H5v16h14zM7 6h4v4H7V6zm0 6h10v2H7v-2zm0 4h10v2H7v-2zm6-9h4v2h-4V7z" />
                            </svg>
                            {/* Text */}
                            {profile.exp} Years
                          </div>
                        )}

                        {/* Render Contract */}
                        {profile.contract_status && (
                          <div className="w-full mb-2 text-black-1 text-xl font-light flex items-center col-span-4">
                            {/* Icon */}
                            <svg
                              className="mr-2"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="18"
                              height="18"
                            >
                              <path fill="none" d="M0 0h24v24H0z" />
                              <path d="M17 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2v2h6V1h2v2zm-2 2H9v2H7V5H4v4h16V5h-3v2h-2V5zm5 6H4v8h16v-8z" />
                            </svg>

                            {/* Text */}
                            {profile.contract_status}
                          </div>
                        )}
                        {/* Hourly rate */}
                        {profile.expected_hourly_rate && (
                          <div className="w-full mb-2 text-black-1 text-xl font-light flex items-center col-span-4">
                            {/* Icon */}
                            <svg
                              className="mr-2"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="18"
                              height="18"
                            >
                              <path fill="none" d="M0 0h24v24H0z" />
                              <path d="M17 16h2V4H9v2h8v10zm0 2v3c0 .552-.45 1-1.007 1H4.007A1.001 1.001 0 0 1 3 21l.003-14c0-.552.45-1 1.007-1H7V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-3zM5.003 8L5 20h10V8H5.003zM7 16h4.5a.5.5 0 1 0 0-1h-3a2.5 2.5 0 1 1 0-5H9V9h2v1h2v2H8.5a.5.5 0 1 0 0 1h3a2.5 2.5 0 1 1 0 5H11v1H9v-1H7v-2z" />
                            </svg>
                            {/* Text */}
                            {profile.expected_hourly_rate} $
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                {/* Add text */}
                <div
                  className={`${
                    profile.top_3_technologies &&
                    profile.top_3_technologies.split(",").length > 0
                      ? "col-span-12"
                      : "w-skill"
                  } mt-3`}
                >
                  {/* Show skelton on loading*/}
                  {loading ? (
                    <Skeleton height={35} width={330} />
                  ) : profile.top_3_technologies &&
                    profile.top_3_technologies.split(",").length > 0 ? (
                    <div className=" text-base font-normal mb-2 flex flex-wrap">
                      {profile.top_3_technologies
                        .split(",")
                        .map((technology, index) => (
                          <div
                            key={index}
                            className="flex text-black-2 text-base font-normal p-4 py-1 mr-2 mb-2 rounded-3xl bg-white-1 border-black-2 border font-text whitespace-nowrap cursor-pointer"
                          >
                            {technology && technology}{" "}
                          </div>
                        ))}
                    </div>
                  ) : (
                    <span className="text-white-4 text-base border border-white-4 rounded-3xl px-5 py-1.5 flex flex-row place-items-center">
                      Your best skills will be displayed here
                    </span>
                  )}
                </div>
              </div>

              {/* Show download */}
              <div className="col-span-12 bg-white-1 rounded font-Poppins px-9 pt-9 pb-12 mb-5">
                {(loading  || !profile?.cv_link )? (
                  <div className="col-span-12">
                    <div className="">
                      <Skeleton height={35} width={500} />
                    </div>
                  </div>
                ) : (
                  <div>
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.12.313/build/pdf.worker.min.js">
                      <div
                        style={{
                          border: "1px solid rgba(0, 0, 0, 0.3)",
                          height: "1050px",
                        }}
                      >
                        <Viewer fileUrl={profile?.cv_link ? profile?.cv_link : sampleFile} />
                      </div>
                    </Worker>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
